// Lip sync mouth cue interface (OVR viseme format from Azure Speech)
export interface LipSyncMouthCue {
  start: number;
  end: number;
  /** OVR viseme: sil, PP, FF, TH, DD, kk, CH, SS, nn, RR, aa, E, ih, oh, ou */
  value: string;
}

// Lip sync data structure from Azure Speech
export interface LipSyncData {
  metadata?: {
    soundFile: string;
    duration: number;
  };
  mouthCues: LipSyncMouthCue[];
}

// Response from the funny audio endpoint
export interface FunnyAudioResponse {
  audioUrl: string;
  lipSyncData?: LipSyncData;
}

export const generateFunnyAudio = async (
  pocToken: string,
  accessAuthToken: string,
  leagueName: string,
  leagueId: string,
  platformUserId: string,
  signal?: AbortSignal // Add optional signal parameter
): Promise<FunnyAudioResponse> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/functions/team_name_audio`;

    const requestData = {
      pocToken: pocToken,
      leagueName: leagueName,
      leagueId: leagueId,
      platformUserId: platformUserId,
    };

    const options: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(requestData),
      signal, // Pass the signal to the fetch request
      credentials: "include",
    };

    const response = await fetch(url, options);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[generateFunnyAudio] Error response from backend:", errorText);
      throw new Error("Failed to generate funny audio.");
    }

    // The response body is now JSON with `audioUrl` and optional `lipSyncData` properties.
    const data = await response.json();
    return {
      audioUrl: data.audioUrl,
      lipSyncData: data.lipSyncData,
    };
  } catch (error) {
    // If the fetch was aborted, it will throw an AbortError.
    // We let the caller handle it, as it's an expected behavior.
    console.error("Error in generateFunnyAudio API call:", error);
    throw error;
  }
};
